import React from "react";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div className="page-container">
      <section className="hero">
        <div className="hero-logo">
          <img src="/logo.svg" alt="Puck Stats" className="hero-logo-img" />
        </div>
        <h1>Puck Stats</h1>
        <p>Track your hockey stats like never before</p>
        <div className="download-buttons">
          <a
            href="https://apps.apple.com/us/app/puck-stats/id6745152965"
            target="_blank"
            rel="noopener noreferrer"
            className="app-store-button"
          >
            <img
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="Download on the App Store"
              className="app-store-badge"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.jjclar4.PuckStats"
            target="_blank"
            rel="noopener noreferrer"
            className="app-store-button"
          >
            <img
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              alt="Get it on Google Play"
              className="app-store-badge"
            />
          </a>
        </div>
      </section>

      <div className="page-content">
        <h2 className="page-subtitle">About Puck Stats</h2>
        <p>
          Puck Stats is the ultimate hockey statistics tracking app designed for
          coaches, players, and teams at all levels. From youth hockey to adult
          leagues, Puck Stats makes it easy to track detailed game and season
          statistics with professional-level features.
        </p>

        <h2 className="page-subtitle">Key Features</h2>
        <ul>
          <li>
            Complete Player Tracking: Track goals, assists, points, shots,
            saves, penalties, and advanced stats for skaters and goalies
          </li>
          <li>
            Live Game Tracking: Real-time shot tracking with interactive rink
            visualization
          </li>
          <li>
            Team Management: Manage multiple teams with unlimited players and
            games (Pro version)
          </li>
          <li>
            Detailed Analytics: Comprehensive team and individual player
            statistics with sortable tables
          </li>
          <li>
            Professional Reports: Export beautiful PDF reports of team stats and
            game summaries (Pro version)
          </li>
        </ul>

        <h2 className="page-subtitle">Perfect For</h2>
        <ul>
          <li>Hockey coaches managing team statistics</li>
          <li>Players tracking their personal performance</li>
          <li>Parents following their children's hockey progress</li>
        </ul>

        <h2 className="page-subtitle">Pro Features ($24.99 USD)</h2>
        <ul>
          <li>Unlimited teams and games</li>
          <li>PDF export functionality</li>
          <li>Team and game deletion capabilities</li>
          <li>Lifetime updates with a one-time purchase</li>
        </ul>

        <h2 className="page-subtitle">Getting Started</h2>
        <p>
          Ready to start tracking your hockey stats? Check out our{" "}
          <Link
            to="/how-to-use"
            style={{ color: "#4B9CD3", fontWeight: "bold" }}
          >
            How to Use guide
          </Link>{" "}
          to learn how to make the most of Puck Stats.
        </p>

        <p>
          We're committed to protecting your privacy. Read our{" "}
          <Link
            to="/privacy-policy"
            style={{ color: "#4B9CD3", fontWeight: "bold" }}
          >
            Privacy Policy
          </Link>{" "}
          to learn how we handle your data.
        </p>
      </div>
    </div>
  );
}

export default Home;
